export const partnership = {
  bannerTitle: 'PARTNER&shy;PROGRAMM VON HAUSHELD',
  bannerText:
    'Profitieren Sie von unserer Aktion „Handwerker werben Handwerker" und erhalten Sie und Ihre Kollegen eine Gutschrift im Wert von CHF 100.- bei jeder erfolgreichen Vermittlung.',
  bannerButtonText: 'Jetzt Ihre Kollegen vermitteln',
  advantageTitle: 'Ihre Vorteile im Überblick',
  advantageSubtitle1: 'Für Sie',
  advantageSubtitle2: 'Für Ihre Kollegen',
  money: 'Gutschrift CHF 100.-',
  advantageText1:
    'Sie erhalten Ihre Gutschrift, sobald Ihr Kollege die erste Rechnung bezahlt hat.',
  advantageText2:
    'Ihr Kollege erhält seine Gutschrift, sobald sein Profil erfolgreich angemeldet ist und sein Profil aktiv ist.',
  advantageText3:
    'Sie erhalten für jede erfolgreiche Vermittlung eine Gutschrift im Wert von CHF 100.-',
  advantageText4:
    'Ihre Kollegen erhalten bei erfolgreicher Anmeldung einen Neukundenrabatt im Wert von CHF 100.-',
  requirementTitle: 'Vermittlungs-Voraussetzungen',
  requirementSubtitle:
    'Ihre Kollegen sollten die unten aufgezeigten Punkte erfüllen, um als Partner in Frage zu kommen:',
  requirementText1: 'Die Firma muss eine eigene Webseite besitzen.',
  requirementText2: 'Das Leistungsangebot muss sich mit unseren bestehenden Projekten decken.',
  requirementText3: 'Das Leistungsangebot muss sich mit unseren Dienstleistungen decken.',
  requirementText4: 'Die Firma muss einen Sitz in der Schweiz besitzen.',
  requirementSubtitle1: 'Eigene Webseite',
  requirementSubtitle2: 'Projekte',
  requirementSubtitle3: 'Dienstleistung',
  requirementSubtitle4: 'Sitz in der Schweiz',
  creditTitle: 'Ganz einfach zu Ihrer Gutschrift',
  creditFormTitle: 'Kontaktdaten angeben',
  company: 'Firma',
  yourDetails: 'Angaben zu Ihnen',
  friendsDetails: 'Angaben Ihres Kollegen',
  comment: 'Bemerkungen',
  formButtonText: 'Am Partnerprogramm teilnehmen',
  successText: 'Ihre Kontaktdaten wurden erfolgreich zugesendet.',
}
